export default __webpack_public_path__ + "static/media/ic-user-icon.f618825c.svg";